import * as R from 'ramda';
import { IDeveloperContact } from '../api/newbuildings';
import { IAppState } from '../common/state';

export function getDeveloperPresenter(state: IAppState) {
  const contacts = R.pathOr<IDeveloperContact[]>([], ['results', 'newbuildingInfo', 'contacts'], state);

  const hasDeveloper = contacts.some(item => item.isBuilder);

  if (hasDeveloper) {
    return undefined;
  }

  const developerPresenters = contacts.filter(item => !item.isBuilder);

  return developerPresenters.length > 1 ? undefined : developerPresenters[0];
}
